module.exports = __webpack_public_path__ + "img/保定市腾运旧机动车交易市场股份有限公司.b410d99c.jpg";